import { TFacet } from "../../../search/model/SearchResponse";
import { IOrganisationIndex } from "../../model/OrganisationIndex";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";

export type TOrganisationIndexTreeChild =
  | IOrganisationIndex
  | IOrganisationIndexGroup;
export interface TOrganisationIndexTreeItem {
  id: number;
  connectedIds: string;
  item: TOrganisationIndexTreeChild;
  parent: TOrganisationIndexTreeChild;
  key: string;
  title: string;
  type: "group" | "index";
  children: TOrganisationIndexTreeItem[];
  getCount(): number;
  setCount(value: number): void;
  _count: number;
  _filter?: string;
  withFilter(filter: string | undefined): TOrganisationIndexTreeItem;
  collectIds(): string[];
  print(prefix?: string): string;
}

const mapper = (
  itm: TOrganisationIndexTreeChild,
  parentItem: TOrganisationIndexTreeChild,
  item: TOrganisationIndexTreeChild,
  countAttributeCollection?: TFacet,
  keyPrefix: string = ""
) => {
  let prefix = true ? "" : `${keyPrefix}${item.id.toString()}-`;
  return OrganisationIndexTreeItemMapper(
    itm,
    parentItem,
    prefix,
    countAttributeCollection
  );
};

const OrganisationIndexTreeItemMapper = (
  item: TOrganisationIndexTreeChild,
  parent?: TOrganisationIndexTreeChild,
  keyPrefix: string = "",
  countAttributeCollection?: TFacet
) => {
  let type = "index";
  let connectedIds = "";

  let _children: TOrganisationIndexTreeItem[] = [];
  let _ids: string[] =
    (item as any).groupIds?.split("-") || (item as any).indexIds?.split("-");
  if (item.hasOwnProperty("indexTypeGroupId")) {
    type = "group";

    connectedIds = (item as IOrganisationIndexGroup).groupIds;
    _children =
      item.groups?.map((child) =>
        mapper(child, item, item, countAttributeCollection, keyPrefix)
      ) || [];
  }
  if (item.hasOwnProperty("children")) {
    type = "group";
    connectedIds = (item as IOrganisationIndex).indexIds;
    _children = [
      ..._children,
      ...((item as IOrganisationIndexGroup).children?.map((child) =>
        mapper(child, item, item, countAttributeCollection, keyPrefix)
      ) || [])
    ];
  }
  const getCount = () => {
    let count = Object.keys(countAttributeCollection || {}).reduce(
      (prev, next) => {
        if (_ids?.find((id) => id == next)) {
          return prev + (countAttributeCollection?.[next] || 0);
        }
        return prev;
      },
      0
    );
    let total =
      _children.reduce((prev, next) => prev + next.getCount(), 0) + count;
    return total;
  };

  return {
    id: item.id,
    item,
    //parent,
    key: `${keyPrefix}${item.id}`,
    type,
    title: item.name,
    connectedIds,
    _count: getCount(),

    get children() {
      let criteria = this._filter || "";

      if (!criteria) {
        _children.forEach((child) => child.withFilter(""));
        return _children;
      }
      _children.forEach((child) => child.withFilter(criteria));
      if (item.contains(criteria)) {
        return _children.filter((child) => {
          if (child.type === "group" && child.item.contains(criteria)) {
            return true;
          }
          return child.item.contains(criteria);
        });
      }
      return _children.filter((child) => child.item.contains(criteria));
    },
    getCount,
    setCount(value: number) {
      this._count = value;
    },
    withFilter(filter: string) {
      this._filter = filter;
      return this;
    },
    collectIds() {
      return [
        item.id.toString(),
        ..._children.map((child) => child.collectIds())
      ];
    },
    print(prefix?: string) {
      let result = "";
      result += `${prefix}${item.name}\n`;
      for (let _val of _children) {
        result += _val.print(prefix + "  ") + "\n";
      }

      return result;
    }
  } as TOrganisationIndexTreeItem;
};
const OrganisationIndexTreePresentationModel = (
  data: IOrganisationIndexGroup[],
  countAttributeCollection?: TFacet
) => {
  return data.map((itm, index) => {
    let result = OrganisationIndexTreeItemMapper(
      itm,
      undefined,
      "",
      countAttributeCollection
    );

    return result;
  });
};

export default OrganisationIndexTreePresentationModel;
